export const ReissueCardRoutes = {
    ROOT: "/reissue-card",
    REISSUE: "/reissue-card/reissue",
    SIGNING: "/reissue-card/signing",
    SUCCESS: "/reissue-card/success",
};



// WEBPACK FOOTER //
// ./src/components/reissueCard/ReissueCardRoutes.ts